import { Directive, Inject, Input } from "@angular/core";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { SearchbarActions } from "./actions";
import { SEARCHBAR_STATE_PROP } from "./state-props";

@Directive({
    selector: "[common-searchbar-actions]",
    exportAs: "SearchbarActions",
})
export class CommonSearchbarActionsDirective {
    @Input("searchbarStateProp") public stateProp: string;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(SEARCHBAR_STATE_PROP) public rootProp,
    ) { }

    public onSearchTextChange(searchText) {
        this.ngRedux.dispatchFactory(
            SearchbarActions.SEARCH_TEXT_CHANGED,
            this.rootProp,
            this.stateProp,
            searchText,
        );
    }

    public reset() {
        this.onSearchTextChange("");
    }
}
